import React from 'react';
import logo from './logo.svg';
import './App.css';
import { MapPage } from './map/map-page';
import { ApolloProvider } from '@apollo/react-hooks';
import { AppApolloProvider } from './app-apolloprovider';

function App() {
  return (
    <AppApolloProvider>
      <div className="App">
        {/* <header className="App-header">Χάρτης Σημείων Συλλογής Μπαταριών</header> */}
        <MapPage></MapPage>
      </div>
    </AppApolloProvider>
  );
}

export default App;
